import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './Search.css';

interface SearchResult {
  property_id: string;
  name: string;
}

const Search: React.FC = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState<SearchResult[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState<SearchResult | null>(null);

  const searchProperties = useCallback(async (term: string) => {
    if (!term.trim()) {
      setResults([]);
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`https://${process.env.REACT_APP_BASE_URL}/getNames`);
      const data = await response.json();
      const parsedData = JSON.parse(data.body);
      
      const filteredResults = parsedData
        .filter((result: SearchResult) => 
          result.name.toLowerCase().includes(term.toLowerCase())
        )
        .slice(0, 10);
      
      setResults(filteredResults);
    } catch (error) {
      console.error('Search error:', error);
      setResults([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      searchProperties(searchTerm);
    }, 300);

    return () => clearTimeout(timer);
  }, [searchTerm, searchProperties]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedProperty) {
      localStorage.setItem('selectedPropertyId', selectedProperty.property_id);
      localStorage.setItem('selectedPropertyName', selectedProperty.name);
      navigate(`/property/${selectedProperty.property_id}`);
    }
  };

  const handleResultClick = (result: SearchResult) => {
    setSelectedProperty(result);
    setSearchTerm(result.name);
    setResults([]);
    navigate(`/property/${result.property_id}`);
  };

  return (
    <div className="search-container">
      <div className="search-content">
        <img src="/logo_symbol.png" className="search-logo" alt="Comparent logo" onClick={() => navigate('/')} />
        <form onSubmit={handleSearch} className="search-form">
          <div className="search-input-container">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search for apartments..."
              className="search-input"
            />
            {(results.length > 0 || isLoading) && (
              <div className="search-dropdown">
                {isLoading ? (
                  <div className="search-dropdown-item">
                    <div className="loading-dots">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                ) : (
                  results.map((result) => (
                    <div
                      key={result.property_id}
                      className="search-dropdown-item"
                      onClick={() => handleResultClick(result)}
                    >
                      <div className="result-title">{result.name}</div>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
          <button type="submit" className="search-button">
            Search
          </button>
        </form>
      </div>
    </div>
  );
};

export default Search; 